export const initialLogInData = {
  email: "",
  password: ""
};
export const initialSignUpData = {
  firstName: "",
  lastName: "",
  email: "",
  password: ""
};
export const guestData = {
  email: "omkarchaskar1402@gmail.com",
  password: "omkarchaskar1402"
};
